import { render, staticRenderFns } from "./ModalImportFile.vue?vue&type=template&id=0f6a9c88&scoped=true"
import script from "./ModalImportFile.vue?vue&type=script&lang=js"
export * from "./ModalImportFile.vue?vue&type=script&lang=js"
import style0 from "./ModalImportFile.vue?vue&type=style&index=0&id=0f6a9c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a9c88",
  null
  
)

export default component.exports